import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';


class StoryCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    let bannerImgUrl = this.props.story.image_cover;
    let categoryName = this.props.story.category_name;
    let title = this.props.story.storyTitle;
    let thumbnailCopy = this.props.story.storyThumbnailCopy;
    let author = this.props.story.full_name;

    let isExternalAsset = this.props.story.is_external_asset;
    let externalAssetName = this.props.story.external_asset_name;


    let organizationName = '';
    organizationName = this.props.story.organization_name;


    if (isExternalAsset) {
      if (externalAssetName) {
        organizationName = externalAssetName;
      }
    } else {
      if (this.props.story.organization_name) {
        organizationName = this.props.story.organization_name;
      }
    }



    //let organizationId = this.props.story.organization;
    let storyUrl = '/story/' + this.props.story.id;


    return(
      <main>
        <div className="storyCard-outerWrapper">
          <Link to={storyUrl}><div className="storyCard">


            <div className="storyCard-bannerWrapper">

              <img className="storyCard-bannerFilter" src="/images/stories/shim_stories.gif" />

              <div className="storyCard-banner"><img src={bannerImgUrl} /></div>

            </div>



            <div className="storyCard-body">
              <div className="storyCard-category">
                {categoryName}
              </div>

              <div className="storyCard-title">
                {title}
              </div>

              <div className="storyCard-thumbnailCopy">
                {thumbnailCopy}
              </div>

              <div className="storyCard-author">
                Via {organizationName}
              </div>

            </div>


          </div></Link>
        </div>


      </main>
    )
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    Link
  }
)(StoryCard);



// WEBPACK FOOTER //
// ./src/components/storyComponents/StoryCard.jsx